import { render, staticRenderFns } from "./DictionaryItem.vue?vue&type=template&id=38721ab8&"
import script from "./DictionaryItem.vue?vue&type=script&lang=js&"
export * from "./DictionaryItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports